import { render, staticRenderFns } from "./CadastrarHelp.vue?vue&type=template&id=25aafd2c&scoped=true"
import script from "./CadastrarHelp.vue?vue&type=script&lang=js"
export * from "./CadastrarHelp.vue?vue&type=script&lang=js"
import style0 from "./CadastrarHelp.vue?vue&type=style&index=0&id=25aafd2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aafd2c",
  null
  
)

export default component.exports